<template>
  <div>
    <div style="margin-bottom: 32px; margin-top: -8px">
      <div class="content-input">
        <div class="content-input-item">
          <DatePickerRange title="上传时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <label>审核状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <el-button type="primary" @click="getPage"> 查询 </el-button>
        </div>
      </div>
    </div>
    <div>
      <el-table
          ref="multipleTableRef"
          :data="pageDataList"
          style="width: 100%"
          border
          @cell-click="toggleSelection"
          v-loading="listLoading"
      >
        <el-table-column label="头像">
          <template #default="scope">
            <el-image style="width: 80px; height: 80px" :src="scope.row.smallImg" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
          </template>
        </el-table-column>
        <el-table-column property="createTime" label="上传时间"/>
        <el-table-column property="" label="审核状态">
          <template #default="scope">
            {{ scope.row.state == 0?'待审核':scope.row.state == 1?'审核通过':scope.row.state == 2?'审核不通过':'' }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../../../components/DatePickerRange'
import {getResumeHeadImgList} from '@/api/url'
import { getFormData } from '@/api/api'
import ImgViewer from '../../../../assets/js/imageViewer'

export default {
  name: "HeadImgList",
  components: { DatePickerRange },
  props: {
    value: Object
  },
  data() {
    return {
      userId: this.value.id,

      sort: 1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      stateArray: [
        {label: '不限', value: -1},
        {label: '待审核', value: 0},
        {label: '审核通过', value: 1},
        {label: '审核不通过', value: 2},
      ],
      state: -1,

      //搜索
      searchType: '',
      searchValue: '',

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //排序
    // sortChange(column) {
    //   if(column.prop == 'chatTime') {
    //     if(column.order == 'descending') {
    //       this.sort = 1;
    //     } else if(column.order == 'ascending') {
    //       this.sort = 2;
    //     }
    //   } else if(column.prop == 'chatNum') {
    //     if(column.order == 'descending') {
    //       this.sort = 3;
    //     } else if(column.order == 'ascending') {
    //       this.sort = 4;
    //     }
    //   } else if(column.prop == 'chatViolationNum') {
    //     if(column.order == 'descending') {
    //       this.sort = 5;
    //     } else if(column.order == 'ascending') {
    //       this.sort = 6;
    //     }
    //   }
    //   this.getPage();
    // },

    getPage() {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['id'] = this.userId;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['state'] = this.state;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getResumeHeadImgList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.img)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {

      // //更新用户日志
      // if(column.label == '用户日志') {
      //   Dialog.open({
      //     title: '用户日志',
      //     component: UserLogDialog,
      //     data: {
      //       id: row.userId
      //     },
      //     close: () => {
      //       row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
      //     }
      //   })
      // }

    },


  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
